<template>
  <div :class="{ 'next-background': mode === 'home' }">
    <mainindex>
      <div
        v-if="!islogmode"
        class="content"
      >
        <!--<div class="content" v-if="gen._UID && !islogmode">-->
        <!--HEADER-->
        <page-header
          v-if="mode !== 'home'"
          :menu-tree="menu"
          :cur-page="mode"
          @nav="go($event)"
          @save-prj="savePrj()"
          @clone-prj="cloneProject()"
          @new-prj="newPrj"
          @openlogspanel="toggleLogsPanel"
        ></page-header>
        <!--HEADER-->

        <!--BODY-->
        <div
          class="body"
          :class="['full-menu']"
        >
          <template v-if="mode==='home'">
            <home
              @new-prj="newPrj"
              @load-prj="go('projects.my')"
              @nav="go($event)"
            ></home>
          </template>
          <template v-else-if="mode==='startprj'">
            <start-prj @nav="go($event)"></start-prj>
          </template>
          <template v-else-if="mode === 'gestPhoto'">
            <gest-photo @nav="go($event)" />
          </template>
          <template v-else-if="mode==='projects.my'">
            <prj-finder
              key="MY"
              filter="MY"
              title="My Projects"
              :rows-number="5"
              order-by="11D"
              :cols="cols"
              @open="openPrj($event)"
            ></prj-finder>
          </template>
          <template v-else-if="mode==='projects.ext'">
            <prj-finder
              key="OTHERPRJ"
              filter="OTHERPRJ"
              title="Other Projects In My Store"
              :rows-number="5"
              order-by="11D"
              :cols="cols"
              @open="openPrj($event)"
            ></prj-finder>
          </template>
          <template v-else-if="mode==='projects.clinv'">
            <prj-finder
              key="CLOSED"
              filter="CLOSED"
              title="Closed Projects"
              :rows-number="5"
              order-by="11D"
              :cols="cols"
              @open="openPrj($event)"
            ></prj-finder>
            <prj-finder
              key="INACTIVE"
              filter="INACTIVE"
              title="Inactive Projects"
              :rows-number="5"
              order-by="11D"
              :cols="cols"
              @open="openPrj($event)"
            ></prj-finder>
          </template>
          <template v-else-if="mode==='notifications'">
            <notifications></notifications>
          </template>
          <template v-else-if="mode==='itemsearch'">
            <article-search @nav="go($event)"></article-search>
          </template>
          <template v-else-if="mode === 'renders'">
            <renders @nav="go($event)" />
          </template>
          <template v-else-if="mode==='configurator'">
            <configure @nav="go($event)"></configure>
          </template>
          <template v-else-if="mode==='3dview' || mode === 'planner'">
            <view3d
              :load-header-on-start="true"
              @nav="go($event)"
            />
          </template>
          <template v-else-if="mode==='2dview'">
            <view2d
              :load-header-on-start="true"
              @nav="go($event)"
            />
          </template>
          <template v-else-if="mode==='compositions'">
            <compositions
              :apply-header="true"
              @nav="go($event)"
            />
          </template>
          <template v-else-if="mode==='offerview'">
            <offer></offer>
          </template>
          <template v-else-if="mode==='summary'">
            <prj-summary />
          </template>
          <template v-else-if="mode==='customerinfo'">
            <customer-info />
          </template>
          <template v-else-if="mode==='prjlog'">
            <prj-log />
          </template>
          <template v-else-if="mode==='delivery'">
            <delivery />
          </template>
          <template v-else-if="mode==='promotions'">
            <promotions />
          </template>
          <template v-else-if="mode==='json'">
            <d-json :value="prj" />
          </template>
          <template v-else-if="mode === 'myprofile'">
            <my-profile />
          </template>
          <template v-else>
            <h1>::::{{ mode }}::::</h1>
          </template>
        </div>
        <!--BODY-->
      </div>
      <home
        v-else
        @new-prj="newPrj"
        @load-prj="go('projects.my')"
        @nav="go($event)"
      ></home>
    </mainindex>

    <app-settings
      v-if="showSettings"
      @close="showSettings = false"
    ></app-settings>
  </div>
</template>

<script>
import "../../../scss/mepsaws.scss";
import index from "@configurator/index";
import {customImport} from "@/utils";
import { bus } from "@store/dau";
import {App} from "@3cad/nextcore";
import {ProjectsAPI} from '@3cad/nextcore';

export default {
    mixins: [index],
    components: {
        pageHeader: () => customImport("comp/pageHeader.vue"),
        gestPhoto: () => customImport("pages/gestPhoto.vue")
    },
    data() {
        return {
            menu: require('@assets/next/json/menu.json'),            
        }
    },
    computed: {
        paddingClass() {
            switch(this.mode){
                case 'home':
                    return 'no-menu';
                case 'startprj':
                    return 'mid-menu';
                default:
                    return 'full-menu';
            }
        }
    },
    created() {
      localStorage.backsite = this.preferences.backsite;
    },
    watch: {
        user: {
          handler: function (newVal) {
            // TODO: Guardare i seguenti link
            // https://en.wikipedia.org/wiki/Language_localisation#Language_tags_and_codes
            // http://www.rfc-editor.org/rfc/bcp/bcp47.txt#
            // https://www.w3.org/International/articles/language-tags/
            if (newVal && newVal.shop && newVal.shop.country.toUpperCase() === "US") {
              this.preferences.config.measures.length = "EX";
              this.preferences.config.measures.volume = "CI";
              this.preferences.config.measures.weight = "LB";
              this.preferences.config.currency = "USD";
            } else if (newVal && newVal.shop && newVal.shop.country.toUpperCase() === "CA") {
              this.preferences.config.measures.length = "EX";
              this.preferences.config.measures.volume = "CI";
              this.preferences.config.measures.weight = "LB";
              this.preferences.config.currency = "CAD";
            } else if (newVal && newVal.shop && newVal.shop.country.toUpperCase() === "GB") {
              //  this.preferences.config.measures.length = 'EX';
              //  this.preferences.config.measures.volume = 'CI';
              //  this.preferences.config.measures.weight = 'LB';
              // this.preferences.config.currency = "GBP";
            } else if (newVal && newVal.shop && newVal.shop.country.toUpperCase() === "UK") {
              // this.preferences.config.measures.length = 'EX';
              // this.preferences.config.measures.volume = 'CI';
              // this.preferences.config.measures.weight = 'LB';
              // this.preferences.config.currency = "GBP";
            } else if (newVal && newVal.shop && newVal.shop.country.toUpperCase() === "EN") {
              this.preferences.config.measures.length = "EX";
              this.preferences.config.measures.volume = "CI";
              this.preferences.config.measures.weight = "LB";
              this.preferences.config.currency = "USD";
            } else if (newVal && newVal.shop && newVal.shop.country.toUpperCase() === "CH") {
              this.preferences.config.currency = "CHF";
            } else if (newVal && newVal.shop && newVal.shop.country.toUpperCase() === "JP") {
              this.preferences.config.currency = "JPY";
            } else if (newVal){
              this.preferences.config.measures.length = "MM";
              this.preferences.config.measures.volume = "CR";
              this.preferences.config.measures.weight = "KG";
              this.preferences.config.currency = "EUR";
            }
          },
          deep: true
        }
      },
      methods:{
      cloneProject() {
        var vm = this;
        this.$store.dispatch("project/save", { clone: false }).then((res) => {
        this.$store.commit("resetLoading");
        var title = "copia - " + (this.prj.des != "" ? this.prj.des : this.prj.id);
        this.$ApraAsk({
          title: this._trans("Attenzione"),
          body: this._trans("Sicuro di voler duplicare il progetto?"),
        })
          .then((data) => {
              bus.$emit("startLoading", vm._trans("Cloning project"));
              vm.$store.dispatch("project/save", { clone: true }).then((res) => {
                vm.$store.commit("resetLoading");
                vm.prj.des = title;
                vm.$store.dispatch("project/save", { clone: false }).then((res) => {
                  vm.$store.commit("resetLoading");
                  bus.$emit("savedPrj");
                });
              });
          })
          .catch((mode) => {});
      });
    },
        newPrj() {

            let initPrj = () => {
                if (localStorage['next_goto']) {
                    delete localStorage['next_goto'];
                }

                if (this.preferences.config.customerAssignment && !this.user.guest) {

                    this.$3cadComponent({
                        title: this._trans('Customer assignment'),
                        size: 'xl',
                        component: '_retrieveCustomer',
                        componentData: {},
                        componentEvents: ['select', 'skip']
                    }).then(({event, data}) => {
                        this.$store.commit('project/empty');
                        this.$store.commit('erp/reset');
                        this.resetCustomerParams();

                        //Empty breadcrumb store
                        if (this.$store.state.searchArticle)
                            this.$store.unregisterModule('searchArticle');

                        let customerData = data;
                        if (customerData) {
                            this.prj.customercod = customerData.email;

                            // Fill customer data
                            this.prj.orderaddress[0].email = customerData.email;
                            this.prj.orderaddress[0].firstname = customerData.firstName;
                            this.prj.orderaddress[0].surname = customerData.lastName;
                            this.prj.orderaddress[0].postalcode = customerData.postalCode;
                            this.prj.orderaddress[0].city = customerData.city;
                            this.prj.orderaddress[0].mobile = customerData.mobile;
                            this.prj.orderaddress[0].street = customerData.street;
                            this.prj.orderaddress[0].countrycode = customerData.country;
                            
                            this.prj.orderaddress[0].customname= ""
                            var split = customerData.secondName.split("~")
                             this.prj.orderaddress[0].secondname = split[0];
                            if(split[1]) {
                               this.prj.orderaddress[0].customname = split[1];
                            }
                            
                            if(!this.prj.customerFields.cv) {
                              this.$set(this.prj.customerFields, "cv", {});
                            }

                            this.prj.customerFields.cv.sconto = split[2] ? split[2] : "";
                            this.prj.customerFields.cv.pagamento = split[3] ? split[3] : "";
                            this.prj.customerFields.cv.consegna = split[4] ? split[4] : "";
                            this.prj.customerFields.cv.trasporto = split[5] ? split[5] : "";
                            this.prj.customerFields.cv.garanzia = split[6] ? split[6] : "";
                            this.prj.customerFields.cv.installazioneCollaudo = split[7] ? split[7] : "";
                            this.prj.customerFields.cv.origineMerci = split[8] ? split[8] : "";
                            this.prj.customerFields.cv.spesaConfinamento = split[9] ? split[9] : "";

                            this.prj.customerFields.discount1 = split[10] ? split[10] : "";
                            this.prj.customerFields.discount2 = split[11] ? split[11] : "";
                        }

                        this.prj.isopen = true;
                        this.onNewProject();
                    });
                } else {
                    this.$store.commit('project/empty');
                    this.$store.commit('erp/reset');
                    this.resetCustomerParams();

                    //Empty breadcrumb store
                    if (this.$store.state.searchArticle)
                        this.$store.unregisterModule('searchArticle');

                    this.prj.isopen = true;
                    this.onNewProject();
                }
            };

            if (this.prj.isopen) {
                this.$3cadAsk({
                    title: this._trans('Project not saved'),
                    body: this._trans('Save current project?'),
                    okTitle: this._trans('Yes'),
                    cancelTitle: this._trans('No')
                }).then(data => {
                    this.savePrj().then(initPrj);
                }).catch(mode => {
                    if (mode === 0)
                        initPrj();
                });
            } else
                initPrj();
        },
        onNewProject(assignCustomer = false) {
          this.setCustomerFields();
          this.$set(this.prj, "currency", this.preferences.config.currency || "EUR");
          console.log(this.prj);
          this.go("itemsearch");
        },
        onProjectLoaded() { 
          var vm = this;
          if(!this.prj.customerFields.discount1) {
            this.$set(this.prj.customerFields, "discount1", 0)
          }
          if(!this.prj.customerFields.discount2) {
            this.$set(this.prj.customerFields, "discount2", 0)
          }
          if(!this.prj.customerFields.exchange) {
            this.$set(this.prj.customerFields, "exchange", 0)
          }

          if(!this.prj.customerFields.rows) {
            this.$set(this.prj.customerFields, "rows", []);
          }
          /*App.projectManager
          .recomputePrices()
          .then(() => {*/
            this.prj.rows.forEach(row=>{
              var cfRow = this.prj.customerFields.rows.find(el=>{return el.uid == row.uniqueid})
              if(cfRow) {
                
                row.erp.forEach(erp=>{
                  if(!cfRow.erp) cfRow.erp = []
                  if(!cfRow.erp.find(el=>{return el.cod == erp.cod})) {
                    cfRow.erp.push({cod:erp.cod, pMod: erp.customDataFe.pMod ? erp.customDataFe.pMod : 0, discount1: this.prj.customerFields.discount1, discount2: this.prj.customerFields.discount2, check: erp.customDataFe.pMod ? true : false})
                  }
                })
              }
              else {
                var cfRow = {uid: row.uniqueid, erp: []}
                row.erp.forEach(erp=>{
                  var erp1 = {cod:erp.cod, pMod: erp.customDataFe.pMod > 0? Number(erp.customDataFe.pMod) : 0, discount1: this.prj.customerFields.discount1, discount2: this.prj.customerFields.discount2, check: erp.customDataFe.pMod > 0 ? true : false}
                  if(erp1.pMod > 0) {
                    var tot = erp.getTotal(true, true, true);
                    if(vm.prj.customerFields.exchange > 0 && vm.prj.customerFields.exchange != 1) {
                      var tot = tot*vm.prj.customerFields.exchange/*tot + (tot*vm.prj.customerFields.exchange/100)*/
                    }
                    erp1.discount1 = 100-erp1.pMod*100/tot;
                    erp1.discount2 = 0;
                  }

                  cfRow.erp.push(erp1)
                  
                })
                
                this.prj.customerFields.rows.push(cfRow)
              }
              
          
            })
            this.setCustomerFields();
            this.go('offerview');
          //})
        },
        setCustomerFields() {
          if(!this.prj.customerFields.cv) {
            this.$set(this.prj.customerFields, "cv", {});
          }
         },
         _newPrj() {

            let initPrj = () => {
              
                if (localStorage['next_goto']) {
                    delete localStorage['next_goto'];
                }
                
                this.$store.commit('project/empty');
                this.$store.commit('erp/reset');
                this.resetCustomerParams();

                //Empty breadcrumb store
                if (this.$store.state.searchArticle)
                    this.$store.unregisterModule('searchArticle');

                this.prj.isopen = true;
                this.onNewProject();
            };

            if (this.prj.isopen) {
                this.$3cadAsk({
                    title: this._trans('Project not saved'),
                    body: this._trans('Save current project?'),
                    okTitle: this._trans('Yes'),
                    cancelTitle: this._trans('No')
                }).then(data => {
                    this.savePrj().then(initPrj);
                }).catch(mode => {
                    if (mode === 0)
                        initPrj();
                });
            } else
                initPrj();
        },

      },
      computed: {
        cols() {
            return [
              { id:'guest.fullname', title:this._trans('customer name'), order:5 },
              { id:'id', title:'id', order:0 },
              { id:'usermail', title:'user', order:0 },
              { id:'des', title:'name', order:6 },
              { id:'shop', title:'shop', order:8 },
              { id:'status', title:'status', order:4 },
              { id:'lastedit', title:'last edit', order:11},
              { id:'assign', title: 'assign' }
            ]
        }
      }
  };
</script>
<style scoped lang="scss">
  .no-menu {
    padding-top: 0;
  }
  .mid-menu {
    padding-top: 90px;
    //padding-top: 2.512rem;
    @include media-breakpoint-down(md) {}
  }
  .full-menu {
    //padding-top: 131px;
    @include media-breakpoint-down(md) {
      //padding-top: 5.15rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/custom/mepsaws/start.vue